// Copyright 2026. WebPros International GmbH. All rights reserved.

export enum ACCOUNT_TABS {
    PASSWORD = '#password',
    TWO_FACTOR_AUTH = '#two-factor-auth',
}
